var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-select',{model:{value:(_vm.label),callback:function ($$v) {_vm.label=$$v},expression:"label"}},_vm._l((_vm.labels),function(item,index){return _c('vs-select-item',{key:index,attrs:{"value":item,"text":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }